import { HeadingAPI } from '../components/heading/heading-api.js';
class ContextualBarAPI extends HeadingAPI {
}
export { ContextualBarAPI, };
//# sourceMappingURL=contextual-bar-api.js.map